<template>
  <IndexPc class="pc-only" v-bind="props" :tags="tags" />
  <IndexM class="m-only" v-bind="props" :tags="tags" />
</template>
<script lang="ts" setup>
import IndexPc from './index-pc.vue'
import IndexM from './index-m.vue'
import type { DetailTag } from './interface'
import type { Character } from '~/api/interface/character'

interface DetailDescriptionProps {
  character?: Character | null
}

const props = defineProps<DetailDescriptionProps>()

const digitalTags = useCharacterTags()

const tags = computed(() => {
  const tagArr: DetailTag[] = []

  props.character?.tag_names?.forEach((tagInfo) => {
    const parentTag = digitalTags.value.tags.find((tag) => {
      return tag.tag_name === tagInfo.tag_name
    })

    if (parentTag) {
      const cloneParentTag = { ...parentTag } as DetailTag
      cloneParentTag.children = []

      tagInfo.children?.forEach((child_tag_name) => {
        const childTag = parentTag?.children?.find((child) => {
          return child.tag_name === child_tag_name
        })

        if (childTag) {
          cloneParentTag.children?.push(childTag)
        } else {
          cloneParentTag.children?.push({
            tag_name: child_tag_name,
          })
        }
      })
      if (cloneParentTag.children.length) {
        tagArr.push(cloneParentTag)
      }
    } else {
      const tagDetail = {
        tag_name: tagInfo.tag_name,
        children: tagInfo.children?.map((item) => ({ tag_name: item })) || [],
      }

      if (tagDetail.children.length) {
        tagArr.push(tagDetail)
      }
    }
  })

  return tagArr
})
</script>
<style lang="scss" scoped></style>
